import $ from 'jquery';

import { siteUrl } from './_global.js';

$(function(){
	
	// home link
	$('svg#logo').click(function(e){
		e.preventDefault();
		window.location = siteUrl();
	});
	
	// menu toggle
	$('a.menu-toggle').click(function(e){
		e.preventDefault();
		$('body').toggleClass('menu-open');
		$('body')[0].scrollTop = $('header').offset().top;
	});
	
});